
import { WorkspaceViewArticleItem } from '@/@types/WorkspaceViewArticleItem';
import { dispatchDeleteArticle } from '@/store/dispatchers/articleDispatchers';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { dispatchOpenArticleEditor } from '@/store/dispatchers/articleEditorDispatchers';
import mobileResponsiveService from '@/services/MobileResponsiveService';
import InlineIcon from '@/components/layout/shared/InlineIcon.vue';
import * as routerNames from '@/routerNames';

@Component({
  components: { InlineIcon },
})
export default class MoreButton extends Vue {
  @Prop({ required: true, type: Object }) item!: WorkspaceViewArticleItem;

  get workspaceView() {
    return this.$store.state.workspaceView;
  }

  get allowEditDeleteArticle() {
    return this.workspaceView.workspace ? this.workspaceView.workspace.canEditArticles() : false;
  }

  get isExternalArticle() {
    return this.item && this.item.sourceType && this.item.sourceType !== 'SNAPSHOT';
  }

  get isStaleArticle() {
    return this.isExternalArticle && this.item.syncStatus === 'STALE';
  }

  get isExportAllowed() {
    return this.item.id && !this.isArticleEditPage && this.item.isHasNotes;
  }

  get isMobile() {
    return mobileResponsiveService.isMobileView;
  }

  get isArticleEditPage() {
    return [
      routerNames.ARTICLE_CREATE,
      routerNames.ARTICLE_EDIT,
      routerNames.ARTICLE_VERSION_EDIT,
      routerNames.DRAFT_EDIT,
    ].includes(this.$route.name);
  }

  handleEditArticle() {
    dispatchOpenArticleEditor(this.item.id);
  }

  handleDuplicateArticle() {
    this.$emit('duplicate-article');
  }

  handleMergeArticle() {
    this.$emit('merge-article');
  }

  handleReorderArticles() {
    this.$emit('reorder-articles');
  }

  handleCreateSubArticle() {
    this.$emit('create-sub-article');
  }

  handleCreateGroup() {
    this.$emit('create-group');
  }

  handleCopyArticleUrl() {
    this.$emit('copy-article-url');
  }

  toggleArchiveArticle() {
    this.$emit('toggle-archive');
  }

  handlePrintArticle() {
    this.$emit('print-article');
  }

  handleReconnect() {
    this.$emit('reconnect', this.item);
  }

  handleRemoveArticle() {
    dispatchDeleteArticle(this.item.id);
  }
}
